import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { API_PREFIX } from '../config';

/**
 * PublicCard — redirects to the backend SSR page.
 *
 * In production, nginx already handles this redirect at the server level
 * (location ~ ^/card/([a-zA-Z0-9-]+)$ → return 302 .../card-api/public/card/$1/page).
 *
 * This component handles the same redirect in development (where nginx isn't running)
 * so behaviour is consistent across all environments.
 *
 * The SSR page (/card-api/public/card/UUID/page) has:
 * - Full OG meta tags → WhatsApp/iMessage preview images work
 * - Apple touch icons → iOS "Add to Home Screen" works
 * - PWA manifest → Android shortcut works
 * - Contact info rendered server-side
 */
const PublicCard = () => {
  const { uniqueId } = useParams();

  useEffect(() => {
    const ssrUrl = `${window.location.origin}${API_PREFIX}/public/card/${uniqueId}/page`;
    window.location.replace(ssrUrl);
  }, [uniqueId]);

  return null;
};

export default PublicCard;
